import { SectionReveal, ChapterHeading } from "./Shared";
import { useLang } from "../../i18n";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="nedir" className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8" data-testid="manifesto-section">
      <ChapterHeading index="01" label={t.manifesto.label} title={t.manifesto.title} />
      <SectionReveal delay={0.1}>
        <p className="mt-10 max-w-4xl text-xl font-light leading-relaxed text-[#221A3D] sm:text-2xl lg:text-[1.75rem]" data-testid="manifesto-copy">
          {t.manifesto.a}
          <span className="font-medium text-[#9B7AE8]">{t.manifesto.hi}</span>
          {t.manifesto.b}
        </p>
      </SectionReveal>
    </section>
  );
}
